import { useCallback } from 'react';

export default function usePdfPageLoadHandler({
  containerRef,
  scaleCalculatedRef,
  baseScaleRef,
  originalPageWidthRef,
  originalPageHeightRef,
  manualZoom,
  setPageScale,
  setZoomLevel,
  setZoomInputValue,
  pageRefs,
  pageDimensions,
  setPositionUpdateTrigger,
  highlights,
}) {
  return useCallback((page) => {
    const pageNum = page.pageNumber;

    if (!scaleCalculatedRef.current && containerRef.current && pageNum === 1) {
      const containerWidth = containerRef.current.clientWidth;
      const containerHeight = containerRef.current.clientHeight;
      const isSmallScreen = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

      if (containerWidth > 0 && containerHeight > 0) {
        const viewport = page.getViewport({ scale: 1.0 });
        originalPageWidthRef.current = viewport.width;
        originalPageHeightRef.current = viewport.height;

        const padding = 16;
        const availableWidth = isSmallScreen ? Math.max(window.innerWidth - padding, containerWidth - padding) : containerWidth - padding;
        const scale = Math.min(availableWidth / viewport.width, 3.0);

        if (scale > 0) {
          baseScaleRef.current = scale;
          setPageScale(scale);
          scaleCalculatedRef.current = true;
          if (!manualZoom) {
            setZoomLevel(100);
            setZoomInputValue('100');
          }
        }
      }
    }

    setTimeout(() => {
      const pageElement = document.querySelector(`[data-page-number="${pageNum}"]`);
      if (pageElement && pageRefs.current) {
        pageRefs.current[pageNum] = pageElement;
        const pdfPageElement = pageElement.querySelector('.react-pdf__Page');
        if (pdfPageElement) {
          const rect = pdfPageElement.getBoundingClientRect();
          pageDimensions.current[pageNum] = {
            width: rect.width,
            height: rect.height,
          };
          setPositionUpdateTrigger((prev) => prev + 1);
        }
      }

      if (highlights && highlights.length > 0) {
        setTimeout(() => {
          // highlight effect hook reacts once text layers are available
        }, 500);
      }
    }, 100);
  }, [
    baseScaleRef,
    containerRef,
    highlights,
    manualZoom,
    originalPageHeightRef,
    originalPageWidthRef,
    pageDimensions,
    pageRefs,
    scaleCalculatedRef,
    setPageScale,
    setPositionUpdateTrigger,
    setZoomInputValue,
    setZoomLevel,
  ]);
}
